export const TOKEN_KEY = 'authKey'
export const ADMIN_KEY = 'admin'
export const DISPLAY_MODE_KEY = 'preferredColorScheme'
